// pages/Callback.js

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { oidcManager } from "../services/oauth/OAuthService";
import LoadingOverlay from "../components/loadingBar/LoadingOverlay";
import "./Callback.css";

const Callback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    oidcManager
      .signinRedirectCallback()
      .then(() => {
        // Restore the user's previous path from sessionStorage
        const intendedPath = sessionStorage.getItem("oauth_redirect_path");
        sessionStorage.removeItem("oauth_redirect_path"); // Clean up
        navigate(intendedPath || "/", { replace: true });
      })
      .catch(err => {
        navigate("/error");
      });
  }, [navigate]);

  return (
    <div className="callback-page">
      <LoadingOverlay
        isVisible={true}
        showProgressBar={false}
        message="Signing you in..."
      />
    </div>
  );
};

export default Callback;
